import { Route } from "react-router-dom";
import RequireAuth from "../Auth/RequireAuth";
import SecuredRoute from "../components/common/VFX-UI/SecuredRoute/SecuredRoute";
import {
    permissions,
    roles,
} from "../utility/helpers/claimHelper";
import SettingsDashboard from "../components/Dashboard/SettingsDashboard";
import LookupTypeContainer from "../components/Admin/Lookup/LookupType/LookupTypeContainer";
import LookupValueContainer from "../components/Admin/Lookup/LookupValue/LookupValueContainer";
import LookupGroupContainer from "../components/Admin/Lookup/LookupGroup/LookupGroupContainer";
import UsersContainer from "../components/Users/UsersContainer";
import StatesContainer from "../components/Admin/States/StatesContainer";
import ClaimContainer from "../components/Admin/Claim/ClaimContainer";
import SettingsContainer from "../components/Admin/Settings/SettingsContainer";
import RoleContainer from "../components/Admin/Role/RoleContainer";
import RolePermissionsFormContainer from "../components/Admin/Permissions/Role/RolePermissionsFormContainer";
import CountyContainer from "../components/Admin/County/CountyContainer";
import TemplateEmailContainer from "../components/Template/Email/TemplateEmailContainer";
import AgencyContainer from "../components/Agency/AgencyContainer";

export default (
    <>
        <Route
            path="/settings-page"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={[permissions.ADMIN_LOGIN, roles.SYSTEM_ADMIN]}>
                        <SettingsDashboard />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/lookup/lookup-type"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.ADMIN_SYSTEM}>
                        <LookupTypeContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/agency"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.MANAGE_AGENCIES,
                            permissions.VIEW_REPORTS,
                        ]}
                    >
                        <AgencyContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/email-template"
            element={
                <RequireAuth>
                    {/* <SecuredRoute
                        requiredPermission={[
                          permissions.MANAGE_AGENCIES,
                        ]}
                      > */}
                    <TemplateEmailContainer />
                    {/* </SecuredRoute> */}
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/payroll-deduction-frequency"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_USER,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <LookupValueContainer lookupId="fc8baecf-8ad7-48d1-480b-08dc5f906f19" />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/gift-investment"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_USER,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <LookupValueContainer lookupId="3530426b-6421-4235-480c-08dc5f906f19" />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/lookup/lookup-group"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={permissions.ADMIN_SYSTEM}
                    >
                        <LookupGroupContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/county"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={permissions.ADMIN_SYSTEM}
                    >
                        <CountyContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/users"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_USER,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <UsersContainer organizationId={undefined} />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/states"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={permissions.ADMIN_SYSTEM}
                    >
                        <StatesContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/claim"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={permissions.ADMIN_SYSTEM}
                    >
                        <ClaimContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/settings"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={permissions.ADMIN_SYSTEM}
                    >
                        <SettingsContainer />{" "}
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_LOGIN,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <SettingsDashboard />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/role"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_LOGIN,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <RoleContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/settings-page/role-permissions/:id"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.ADMIN_LOGIN,
                            roles.SYSTEM_ADMIN,
                        ]}
                    >
                        <RolePermissionsFormContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
    </>
);
